import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
    return (
        <Box sx={{mt: 15, py: 7, backgroundColor: '#212121', color: 'white'}}>
            <Container style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <Typography variant="button" display="block" gutterBottom>
                    @copyright 2021 || Md. Mahadi Hassan Riyadh
                </Typography>
                <Box>
                <a style={{ textDecoration: 'none', color: 'white', marginRight: 20}} href="https://www.linkedin.com/in/mahadihassanriyadh/"><LinkedInIcon style={{ fontSize: 40 }} /></a>
                <a style={{ textDecoration: 'none', color: 'white', marginRight: 20}} href="https://github.com/mahadihassanriyadh"><GitHubIcon style={{ fontSize: 40 }} /></a>
                <a style={{ textDecoration: 'none', color: 'white' }} href="mailto:mahadihassanriyadh1@gmail.com"><EmailIcon style={{ fontSize: 40 }} /></a>
            </Box>
            </Container>
        </Box>
    );
};

export default Footer;